export const isEmptyValue = value => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
};

const isSubgroupValid = subgroup => {
    const rows = Array.isArray(subgroup?.rows) ? subgroup.rows : [];
    return rows.every(row => !isEmptyValue(row?.option) && !isEmptyValue(row?.value));
};

const isGroupValid = group => {
    if (isEmptyValue(group?.baseOption) || isEmptyValue(group?.baseValue)) {
        return false;
    }
    const subgroups = Array.isArray(group?.subgroups) ? group.subgroups : [];
    return subgroups.every(isSubgroupValid);
};

export const validateCriteria = criteria => {
    const groups = Array.isArray(criteria) ? criteria : [];
    if (groups.length === 0) return false;
    return groups.every(isGroupValid);
};

export const validateTiers = (tiers, fields) => {
    if (!Array.isArray(tiers) || tiers.length === 0) return false;
    return tiers.every(tier => fields.every(field => !isEmptyValue(tier[field])));
};

export const hasValidImage = (image, file) => {
    const imageCandidate = image !== undefined ? image : file;
    return Array.isArray(imageCandidate) ? imageCandidate.length > 0 : Boolean(imageCandidate);
};
